import { UUID } from 'angular2-uuid';
export interface UserData {
  key: string;
  sessionId: string;
  lastlogindate: string;
  preferred_username: string;
  email: string;
  token: string;
  role?: string[];
}
export class User implements UserData {
  key: string;
  sessionId: string;
  lastlogindate: string;
  preferred_username: string;
  email: string;
  token: string;
  role?: string[];

  constructor(
    key: string,
    lastlogindate: string,
    preferred_username: string,
    email: string,
    token: string,
    role?: string[]
  ) {
    this.key = key;
    this.lastlogindate = lastlogindate;
    this.preferred_username = preferred_username;
    this.email = email;
    this.token = token;
    this.role = role;
    this.sessionId = UUID.UUID().split('-')[0];
  }
}
